// src/composables/globalComposables.ts

import { useToast } from 'vuestic-ui'

export function useGlobalInit() {
  const { init: notify } = useToast()
  return { notify }
}
